// Small 2D vector helpers (same names the game used from the old engine).
export const Vector = {
    add: (a, b) => ({ x: a.x + b.x, y: a.y + b.y }),
    sub: (a, b) => ({ x: a.x - b.x, y: a.y - b.y }),
    mult: (a, scalar) => ({ x: a.x * scalar, y: a.y * scalar }),
    dot: (a, b) => a.x * b.x + a.y * b.y,
    magnitude: (a) => Math.hypot(a.x, a.y),
    normalise: (a) => {
        const length = Math.hypot(a.x, a.y)
        return length === 0 ? { x: 0, y: 0 } : { x: a.x / length, y: a.y / length }
    },
    rotate: (a, angle) => {
        const cos = Math.cos(angle)
        const sin = Math.sin(angle)
        return { x: a.x * cos - a.y * sin, y: a.x * sin + a.y * cos }
    }
}
